import { requestFactory } from '../../RequestFactory';
import { path } from '../../Paths';
import { requestMethods } from '../../../../Constants/requestMethods';

export const getAllExercises = (filter, offsetId) => {
    const url = path.create().getAllExercises(filter, offsetId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getRecentExercises = () => {
    const url = path.create().getRecentExercises();

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};

export const getExercisesByType = (key, filter, offsetId) => {
    const url = path.create().getExercisesByType(key, filter, offsetId);

    const requestConfig = {
        url,
        method: requestMethods.GET,
    };

    return requestFactory.createRequest(requestConfig);
};



// WEBPACK FOOTER //
// ./src/BusinessLogic/Network/API/ExercisesApi/exercisesRequestConfigs.js